var _defs, _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _g3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g4, _path24, _path25, _path26, _path27, _path28, _path29, _g5, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLynxWhiteboardLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lynx-whiteboard-logo_svg__uuid-8b9a91a2-1714-4f71-8152-916b818563c4",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 377.6 477.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".lynx-whiteboard-logo_svg__uuid-35aa9605-2a4f-484e-bf6e-7e02a53ae580{fill:url(#lynx-whiteboard-logo_svg__uuid-d33eae5d-fe27-4f23-933c-2e19cdb4f24d)}.lynx-whiteboard-logo_svg__uuid-546e157c-ef45-43f6-bf0b-9853ca4f7a5d,.lynx-whiteboard-logo_svg__uuid-ff0ce081-27ae-4ef0-a29c-d875993d1b04,.lynx-whiteboard-logo_svg__uuid-93be20b0-37c4-4b69-9b6b-9c3bbf2bca82,.lynx-whiteboard-logo_svg__uuid-dd8951f2-2194-4277-a36b-96976a544cb1{fill:none}.lynx-whiteboard-logo_svg__uuid-3c3e615f-101f-4313-aa19-0374097cc56f{fill:url(#lynx-whiteboard-logo_svg__uuid-c35952c9-f6e7-436f-a26a-102edae40d89)}.lynx-whiteboard-logo_svg__uuid-ff0ce081-27ae-4ef0-a29c-d875993d1b04{clip-path:url(#lynx-whiteboard-logo_svg__uuid-bd26263d-714d-4467-8a4c-bc30c71cb821)}.lynx-whiteboard-logo_svg__uuid-97d0605c-d849-4861-a025-ecb4afa825eb{fill:url(#lynx-whiteboard-logo_svg__uuid-46c98c5d-a4dd-43c4-a31f-17f2e1af9bb0)}.lynx-whiteboard-logo_svg__uuid-5ffbdd28-c32b-487c-a5ea-5dfdb96aa7f2{clip-path:url(#lynx-whiteboard-logo_svg__uuid-14a16f30-ad8f-44fd-8782-6f1255ee4f41)}.lynx-whiteboard-logo_svg__uuid-59eb4435-7fa8-4768-baa5-a6e484f9d0a9{fill:url(#lynx-whiteboard-logo_svg__uuid-4e813053-12ab-4fc8-aa14-44db764cfa92)}.lynx-whiteboard-logo_svg__uuid-3df8d3cb-8256-415c-821e-3ea96b62d59b{fill:url(#lynx-whiteboard-logo_svg__uuid-0c9f947f-f62b-4fa4-a606-0c4cfc7ba1b9)}.lynx-whiteboard-logo_svg__uuid-0e430ab3-e226-4037-9181-51f7f318a24e{fill:url(#lynx-whiteboard-logo_svg__uuid-434c60ff-98c6-4844-9e8b-f9a29a8d4fc2)}.lynx-whiteboard-logo_svg__uuid-93be20b0-37c4-4b69-9b6b-9c3bbf2bca82{clip-path:url(#lynx-whiteboard-logo_svg__uuid-ce05e68b-7e88-416b-bff6-1cee347dca26)}.lynx-whiteboard-logo_svg__uuid-a0dc01d9-6e89-4cd1-8b78-05847040b01a{fill:url(#lynx-whiteboard-logo_svg__uuid-7b2614ba-4476-4f25-a792-6ecb0d0e4284)}.lynx-whiteboard-logo_svg__uuid-cf46ac8c-471e-48c6-aa08-866d2ab22945{fill:url(#lynx-whiteboard-logo_svg__uuid-b3e8d42d-1162-4010-bd72-81d57eeb5007)}.lynx-whiteboard-logo_svg__uuid-387266a8-7994-4679-bb7f-dd8048da7efe{fill:url(#lynx-whiteboard-logo_svg__uuid-5489a164-34c3-4bca-9776-7471fd9df195)}.lynx-whiteboard-logo_svg__uuid-68321f76-e1b5-4e53-badb-4eb86907db30,.lynx-whiteboard-logo_svg__uuid-241ecfe2-2702-448c-8ee9-3e5dbc86f9db{opacity:.1}.lynx-whiteboard-logo_svg__uuid-e5ae19c7-54f0-4bca-b987-e57bfa74a8f5{fill:url(#lynx-whiteboard-logo_svg__uuid-0c6831cf-4958-46e8-89d2-39acf80d4720)}.lynx-whiteboard-logo_svg__uuid-bd522e9d-ecab-42d8-babc-59c93b46f557{fill:url(#lynx-whiteboard-logo_svg__uuid-1081eed7-832f-4766-89d5-1e1a5af99885)}.lynx-whiteboard-logo_svg__uuid-1f5cead0-e1b4-4c60-805d-6e7af52b527a{fill:#ededed}.lynx-whiteboard-logo_svg__uuid-5209cdd3-f818-4925-bceb-54a3bc586b67{fill:#ffd3e1}.lynx-whiteboard-logo_svg__uuid-d953d68c-68f8-42e0-89c8-d7f6e995ddf2{fill:#ff83ed}.lynx-whiteboard-logo_svg__uuid-14c3eebd-8277-4f50-aa8c-40dbc03811ce{fill:#c43dd9}.lynx-whiteboard-logo_svg__uuid-98aeddd2-12f2-4fef-b14e-f3555e048343,.lynx-whiteboard-logo_svg__uuid-241ecfe2-2702-448c-8ee9-3e5dbc86f9db{fill:#38004f}.lynx-whiteboard-logo_svg__uuid-11c43ceb-bbef-4b84-ad68-abd6181b8f3c{fill:#617ef2}.lynx-whiteboard-logo_svg__uuid-b106baf8-52c5-48c7-bfad-f27f11729f4e{fill:url(#lynx-whiteboard-logo_svg__uuid-3a9942e3-cdae-4f38-b2f3-6b7563f325bc)}.lynx-whiteboard-logo_svg__uuid-1790aadf-370b-443b-95af-1f15c9fd7934{fill:url(#lynx-whiteboard-logo_svg__uuid-466e0932-9be2-4c56-8d55-289588fc4f9f)}.lynx-whiteboard-logo_svg__uuid-443a49e0-eb97-4a22-948c-01e66a064424{fill:url(#lynx-whiteboard-logo_svg__uuid-60317ed5-4f05-4f41-bab0-2db243419ec3)}.lynx-whiteboard-logo_svg__uuid-06e42b53-f4ea-44a3-ad60-11ebe2f48886{fill:url(#lynx-whiteboard-logo_svg__uuid-48f2f82e-c274-45c8-b92e-6016213b4248)}.lynx-whiteboard-logo_svg__uuid-d7b8133f-b716-4ca6-bece-45aaae641bed{fill:url(#lynx-whiteboard-logo_svg__uuid-760217f7-c764-449f-aa6c-4fcd12228dc6)}.lynx-whiteboard-logo_svg__uuid-f0f4b6a2-5af9-4b4d-92b9-334b86839aac{fill:url(#lynx-whiteboard-logo_svg__uuid-121ea2ee-4b38-4067-8064-218d36ea0d49)}.lynx-whiteboard-logo_svg__uuid-dd8951f2-2194-4277-a36b-96976a544cb1{stroke:#000;stroke-width:.23px}.lynx-whiteboard-logo_svg__uuid-3e107dfa-09c2-46ac-be4f-0608d27cad88{fill:#f487e5}.lynx-whiteboard-logo_svg__uuid-3e107dfa-09c2-46ac-be4f-0608d27cad88,.lynx-whiteboard-logo_svg__uuid-03bf3889-d6cd-4d04-b4ca-da28fa118783,.lynx-whiteboard-logo_svg__uuid-241ecfe2-2702-448c-8ee9-3e5dbc86f9db,.lynx-whiteboard-logo_svg__uuid-b6cf4379-06e5-4e50-9486-d078a889d89b{isolation:isolate}.lynx-whiteboard-logo_svg__uuid-3e107dfa-09c2-46ac-be4f-0608d27cad88,.lynx-whiteboard-logo_svg__uuid-8e0736ab-5ff7-4629-88c2-835941d78412{opacity:.9}.lynx-whiteboard-logo_svg__uuid-03bf3889-d6cd-4d04-b4ca-da28fa118783{fill:#0d2b30;opacity:.5}.lynx-whiteboard-logo_svg__uuid-7f1b78f2-a1df-42e3-be81-be3a93936b04{fill:url(#lynx-whiteboard-logo_svg__uuid-292f52d4-efc3-4467-9250-983033e3e7fb)}.lynx-whiteboard-logo_svg__uuid-8c112827-03ba-4019-9563-60c1d9bd87b6{fill:url(#lynx-whiteboard-logo_svg__uuid-e4fcc8aa-1dfd-4273-9e1e-8dd4cee9aa2c)}.lynx-whiteboard-logo_svg__uuid-d088ab46-3e14-47db-83b1-301de4def5c9{fill:url(#lynx-whiteboard-logo_svg__uuid-330a1ed4-7e2f-45c8-8391-67bbeac8503b)}.lynx-whiteboard-logo_svg__uuid-a125cc65-2e26-45a0-a448-20a2eb0c13c2{fill:url(#lynx-whiteboard-logo_svg__uuid-043229f1-3921-4f2f-8bf3-122404f988d0)}.lynx-whiteboard-logo_svg__uuid-35df9d4a-a422-4038-a91b-ac15f3bad726{clip-path:url(#lynx-whiteboard-logo_svg__uuid-30799245-4288-46c7-999f-ab9cc072c351)}.lynx-whiteboard-logo_svg__uuid-f9381d00-1196-438b-ad78-553bec995de3{fill:url(#lynx-whiteboard-logo_svg__uuid-71d877bd-290e-44fa-a3c5-093a379cc5ae)}.lynx-whiteboard-logo_svg__uuid-1ce86f1c-55e6-411f-9c60-802a4a63e6c7{fill:url(#lynx-whiteboard-logo_svg__uuid-b514303c-6609-43d5-8c13-f51410eeb8fd)}.lynx-whiteboard-logo_svg__uuid-88032f9e-329d-4674-9cc3-a899f0508b8a{fill:url(#lynx-whiteboard-logo_svg__uuid-e707685e-77ab-42d0-8a6f-9230861092c5)}.lynx-whiteboard-logo_svg__uuid-25cba547-8c03-49ce-89be-c325b9ed1081{fill:url(#lynx-whiteboard-logo_svg__uuid-3e7cb4ef-9197-49b5-aefc-804fbe32cce4)}.lynx-whiteboard-logo_svg__uuid-d629904c-44be-4156-8f48-f62a4f3699c7{fill:url(#lynx-whiteboard-logo_svg__uuid-bd01b8d4-020a-49ca-bd4c-0dce3574b3f3)}.lynx-whiteboard-logo_svg__uuid-7e2545a9-ed12-428a-9938-58181537dfa1{fill:url(#lynx-whiteboard-logo_svg__uuid-6fb3c43e-95e8-42fe-942e-ac61a39497b0)}.lynx-whiteboard-logo_svg__uuid-5e0b87a9-8a3b-494c-ab09-d5cc08a1a3c6{fill:url(#lynx-whiteboard-logo_svg__uuid-4f1e84df-bca7-4dfa-a723-0352e9212473)}.lynx-whiteboard-logo_svg__uuid-3284ac06-094a-401c-838f-a4ca82fbdc27{fill:url(#lynx-whiteboard-logo_svg__uuid-b757cbb4-2624-421c-8e72-8c2811233918)}.lynx-whiteboard-logo_svg__uuid-e903955d-530b-45dc-bfb3-994877dca589{fill:url(#lynx-whiteboard-logo_svg__uuid-c6c45d7f-fc50-48c0-92b9-2d8b1c93187e)}.lynx-whiteboard-logo_svg__uuid-6f855e4d-8d72-40e1-9c86-dc8f641baaaf{fill:url(#lynx-whiteboard-logo_svg__uuid-1d7b7477-0c9a-487d-aa73-4498f43e64a3)}.lynx-whiteboard-logo_svg__uuid-6a1851eb-817c-4337-be59-987c0d797c43{fill:url(#lynx-whiteboard-logo_svg__uuid-fab8e016-dda7-4532-a0d1-1be0154dc853)}.lynx-whiteboard-logo_svg__uuid-e59c9a21-e849-4abd-a254-caad7e0c0f42{fill:url(#lynx-whiteboard-logo_svg__uuid-47423a35-6c8b-4f7a-a361-e1f1d3c3b5eb)}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-48f2f82e-c274-45c8-b92e-6016213b4248",
    x1: 132.76,
    y1: 333.51,
    x2: 214.34,
    y2: 394.98,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#374df2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5543e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8d31ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#b922b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d918a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ed129e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4109b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-466e0932-9be2-4c56-8d55-289588fc4f9f",
    x1: 149.4,
    y1: 400.52,
    x2: 222.91,
    y2: 423,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c2eae",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8c2eae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b0099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-0c6831cf-4958-46e8-89d2-39acf80d4720",
    x1: 476.96,
    y1: -1593.04,
    x2: 510.84,
    y2: -1655.62,
    gradientTransform: "translate(-1372.05 698.45) rotate(52.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#211599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e60f97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-b514303c-6609-43d5-8c13-f51410eeb8fd",
    x1: 206.92,
    y1: 450.21,
    x2: 214.33,
    y2: 450.21,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a44fc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c25b8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lynx-whiteboard-logo_svg__uuid-bd26263d-714d-4467-8a4c-bc30c71cb821"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-546e157c-ef45-43f6-bf0b-9853ca4f7a5d",
    d: "m189.04,167.3l.07.29h0c.1.45-.18.89-.62.99-.4.09-.79-.12-.95-.49l-.12-.28,1.62-.52h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lynx-whiteboard-logo_svg__uuid-30799245-4288-46c7-999f-ab9cc072c351"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-ff0ce081-27ae-4ef0-a29c-d875993d1b04",
    d: "m189.04,167.3l.07.29h0c.1.45-.18.89-.62.99-.4.09-.79-.12-.95-.49l-.12-.28,1.62-.52h0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-7b2614ba-4476-4f25-a792-6ecb0d0e4284",
    x1: -59.87,
    y1: 173.23,
    x2: 213.75,
    y2: 379.42,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#374df2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4109b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-bd01b8d4-020a-49ca-bd4c-0dce3574b3f3",
    x1: 842.83,
    y1: -2167.43,
    x2: 1158.51,
    y2: -2080.85,
    gradientTransform: "translate(-2142.48 698.45) rotate(52.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e67eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fa4bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-b3e8d42d-1162-4010-bd72-81d57eeb5007",
    x1: -66.29,
    y1: 181.75,
    x2: 207.33,
    y2: 387.94,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#374df2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4109b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-4e813053-12ab-4fc8-aa14-44db764cfa92",
    x1: 843.38,
    y1: -2169.41,
    x2: 1159.06,
    y2: -2082.83,
    gradientTransform: "translate(-2142.48 698.45) rotate(52.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e67eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fa4bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-e707685e-77ab-42d0-8a6f-9230861092c5",
    x1: 3323.66,
    y1: 2205.43,
    x2: 3549.38,
    y2: 2267.33,
    gradientTransform: "translate(-2150.43 3704.77) rotate(-21.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#148c17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11f2df"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-e4fcc8aa-1dfd-4273-9e1e-8dd4cee9aa2c",
    x1: 3335.18,
    y1: 2191.4,
    x2: 3582.87,
    y2: 2259.34,
    gradientTransform: "translate(-2150.43 3704.77) rotate(-21.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#107027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12ab6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-4f1e84df-bca7-4dfa-a723-0352e9212473",
    x1: 170.3,
    y1: 93.11,
    x2: 354.57,
    y2: 93.11,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ffac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59d624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-60317ed5-4f05-4f41-bab0-2db243419ec3",
    x1: 254.7,
    y1: 87.48,
    x2: 161.28,
    y2: 87.48,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ffac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59d624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-1d7b7477-0c9a-487d-aa73-4498f43e64a3",
    x1: 3263.49,
    y1: 2284.72,
    x2: 3595.49,
    y2: 2375.77,
    gradientTransform: "translate(-2150.43 3704.77) rotate(-21.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4431d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d42db8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-71d877bd-290e-44fa-a3c5-093a379cc5ae",
    x1: 3339.5,
    y1: 2423.29,
    x2: 3458.25,
    y2: 2423.29,
    gradientTransform: "translate(-2150.43 3704.77) rotate(-21.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4931fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a817fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-fab8e016-dda7-4532-a0d1-1be0154dc853",
    x1: -168.86,
    y1: 10.75,
    x2: 289.8,
    y2: 356.37,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#374df2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f410ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-0c9f947f-f62b-4fa4-a606-0c4cfc7ba1b9",
    x1: 242.77,
    y1: 274.95,
    x2: 266.99,
    y2: 293.19,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#170f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-5489a164-34c3-4bca-9776-7471fd9df195",
    x1: 3270.96,
    y1: 2261.66,
    x2: 3585.81,
    y2: 2348.01,
    gradientTransform: "translate(-2150.43 3704.77) rotate(-21.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c38f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11bdd8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-292f52d4-efc3-4467-9250-983033e3e7fb",
    x1: 242.21,
    y1: 275.88,
    x2: 268.11,
    y2: 295.4,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#170f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-1081eed7-832f-4766-89d5-1e1a5af99885",
    x1: 241.72,
    y1: 275.42,
    x2: 266.33,
    y2: 293.96,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#402a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a11d70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-c6c45d7f-fc50-48c0-92b9-2d8b1c93187e",
    x1: 431.46,
    y1: -1546.91,
    x2: 462.81,
    y2: -1604.82,
    gradientTransform: "translate(-1372.05 698.45) rotate(52.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#211599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e60f97"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lynx-whiteboard-logo_svg__uuid-ce05e68b-7e88-416b-bff6-1cee347dca26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-546e157c-ef45-43f6-bf0b-9853ca4f7a5d",
    d: "m132.03,160.13l.07.29h0c.1.45-.18.89-.62.99-.4.09-.79-.12-.95-.49l-.12-.28,1.62-.52h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lynx-whiteboard-logo_svg__uuid-14a16f30-ad8f-44fd-8782-6f1255ee4f41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-93be20b0-37c4-4b69-9b6b-9c3bbf2bca82",
    d: "m132.03,160.13l.07.29h0c.1.45-.18.89-.62.99-.4.09-.79-.12-.95-.49l-.12-.28,1.62-.52h0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-d33eae5d-fe27-4f23-933c-2e19cdb4f24d",
    x1: 100.9,
    y1: 323.55,
    x2: 151.6,
    y2: 442.99,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c2eae",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8c2eae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b0099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-330a1ed4-7e2f-45c8-8391-67bbeac8503b",
    x1: 177.37,
    y1: 437.43,
    x2: 208.66,
    y2: 437.43,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c25b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a44fc2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-3e7cb4ef-9197-49b5-aefc-804fbe32cce4",
    x1: 110.9,
    y1: 439.54,
    x2: 150.32,
    y2: 439.54,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c25b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a44fc2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-b757cbb4-2624-421c-8e72-8c2811233918",
    x1: 148.58,
    y1: 456.52,
    x2: 155.33,
    y2: 456.52,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a44fc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c25b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-043229f1-3921-4f2f-8bf3-122404f988d0",
    x1: 61.81,
    y1: 113.33,
    x2: 369.53,
    y2: 197.74,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5730d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fa4bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-434c60ff-98c6-4844-9e8b-f9a29a8d4fc2",
    x1: 88.07,
    y1: 38.73,
    x2: 349.62,
    y2: 235.82,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#598cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45e4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-46c98c5d-a4dd-43c4-a31f-17f2e1af9bb0",
    x1: 352,
    y1: 215.76,
    x2: 379.62,
    y2: 236.56,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#170f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-760217f7-c764-449f-aa6c-4fcd12228dc6",
    x1: 358.22,
    y1: 219.23,
    x2: 381.04,
    y2: 236.43,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#402a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a11d70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-c35952c9-f6e7-436f-a26a-102edae40d89",
    x1: 78.89,
    y1: 135.22,
    x2: 229.04,
    y2: 135.22,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4076ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42e5ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-6fb3c43e-95e8-42fe-942e-ac61a39497b0",
    x1: 115.41,
    y1: 41.31,
    x2: 171.21,
    y2: 41.31,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ffac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59d624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-47423a35-6c8b-4f7a-a361-e1f1d3c3b5eb",
    x1: 78.55,
    y1: 70.36,
    x2: 114.82,
    y2: 70.36,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#598cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e91fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-121ea2ee-4b38-4067-8064-218d36ea0d49",
    x1: 50.78,
    y1: 95.28,
    x2: 79.55,
    y2: 95.28,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#598cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e91fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lynx-whiteboard-logo_svg__uuid-3a9942e3-cdae-4f38-b2f3-6b7563f325bc",
    x1: 50.95,
    y1: 209.7,
    x2: 345.27,
    y2: 209.7,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#617ef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f478ab"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-06e42b53-f4ea-44a3-ad60-11ebe2f48886",
    d: "m206.87,60.18c-.02-.19-.04-.38-.04-.59-.02-2.78.42-5.02,1.57-7.56.23-.5.46-1,.69-1.5-1.13-.9-2.26-1.78-3.3-2.76-15.51,10.65-55.31,47.73-58.58,76.32,6.04,4.1,30.95,19.95,38.31,20.82.37.04.74.1,1.11.14-.08-.5-.16-1-.24-1.51-2.91-19.68,4.64-40.15,20.48-83.37h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-1790aadf-370b-443b-95af-1f15c9fd7934",
    d: "m186.54,117c6.57-47.51,41.16-68.36,21.21-108.89-3.55,15.78-8.39,30.42-16.22,44.4-8.61,16.13-24,29.12-33.79,46.77-1.53,6.08,2.8,11.84,8.72,18.47,6.69-.44,13.37-.87,20.08-.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-e5ae19c7-54f0-4bca-b987-e57bfa74a8f5",
    d: "m190.4,164.62c9.35,1.78,18.75,3.37,28.24,4.07,4.39.32,8.89.49,13.34.23.77-.8,1.54-1.59,2.3-2.4-3.5-10.43-9.12-22.31-8.53-36.38,1.73-41.12-3.87-60.47-11.88-93.82-.03,0-2.06,10.51-2.11,10.49-26.11,49.86-28.75,72.26-25.37,96.75,1.04,7.56,2.4,14.56,4.01,21.07h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-1ce86f1c-55e6-411f-9c60-802a4a63e6c7",
    d: "m211.8,46.81c.72-3.22,1.05-6.51,1.09-9.78.06-3.28-.17-6.55-.64-9.78-.46-3.24-1.33-6.39-2.06-9.56-.74-3.18-1.64-6.31-2.52-9.53l.17-.08c1.82,2.82,3.12,5.93,4.12,9.12,1.01,3.2,1.43,6.55,1.74,9.87.3,3.33.35,6.68.1,10-.28,3.32-.86,6.61-1.82,9.78l-.18-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-14c3eebd-8277-4f50-aa8c-40dbc03811ce",
    d: "m214.02,36.3c.28,5.68-2.28,10.99-4.44,16.1-2.25,5.11-5.06,9.98-7.31,15.07-2.2,4.92-4.5,10.38-6.41,15.45-8.6,21.88-12.07,41.78-7.51,65.06.94,5.47,1.97,10.92,3.27,16.31l-1.15-1.03c6.58.96,13.32.64,19.95-.07,6.8-.65,13.48-2.32,19.93-4.02.02.07,0,.14-.07.17-3.09,1.45-6.33,2.51-9.6,3.48-3.28.91-6.62,1.66-9.99,2.25-6.78,1.16-13.69,1.59-20.57.89-.58-.06-1.03-.49-1.15-1.03-1.38-5.45-2.55-10.97-3.37-16.53-2.87-16.68-1.89-34.03,3.33-50.16,4.13-13.42,9.84-26.26,16.34-38.64,2.58-4.93,5.14-9.91,6.98-15.17.87-2.62,1.66-5.36,1.47-8.12,0-.08.05-.15.13-.15.07,0,.14.05.15.13h.02Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-14c3eebd-8277-4f50-aa8c-40dbc03811ce",
    d: "m230.11,159.27c-1.84-4.37-3.7-8.8-4.69-13.56-2.59-14.14-.05-28.53-.93-42.75-.44-18.78-5.13-38.48-8.3-56.2-.35-1.48-.86-3.68-1.2-5.17-.33-1.42-.86-3.75-1.21-5.16v-.04s.02.07.07.05c-.07-.02-.11-.1-.09-.17s.1-.11.17-.09c.05,0,.11.13.1.13,0,.02.03.1.03.13l.04.16c.05.18.19.79.24.98.19.79.73,3.1.92,3.94.34,1.48.84,3.64,1.18,5.08,0,.04.02.09.03.12.03.05-.05-.1-.12-.06l.13.11c4.11,18.53,9.22,37,10.21,56.07.64,9.51.82,19.07.3,28.55-.23,4.7-.27,9.38.32,13.99s1.91,9.18,3.05,13.8c.05.15-.2.24-.26.09h.01Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-1f5cead0-e1b4-4c60-805d-6e7af52b527a",
    d: "m373.46,239.32c.65,1.56,2.12,3.26,1.99,5.49-.12,2.07-1.93,9.76-3.52,13.76,0,0,1.17-11.32,1.11-14.77-.03-1.68.43-4.49.43-4.49h0Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "lynx-whiteboard-logo_svg__uuid-35df9d4a-a422-4038-a91b-ac15f3bad726"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-dd8951f2-2194-4277-a36b-96976a544cb1",
    d: "m188.82,171.15l.26-.08.26-.08.26-.08.26-.08s6.33,18.56-.74-3.23l-.2-.87-.43.14-.43.14-.43.14-.43.14.35.83c7.07,21.78,1.28,3.05,1.28,3.05v-.02Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "lynx-whiteboard-logo_svg__uuid-b6cf4379-06e5-4e50-9486-d078a889d89b",
    width: 6,
    height: 13,
    transform: "translate(186.83 165.84)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAANCAYAAACKCx+LAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQYlWNgYGBgmK29gnm29gpmBmQAE8CQGAXoAADiuQXF6DzhnwAAAABJRU5ErkJggg=="
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-546e157c-ef45-43f6-bf0b-9853ca4f7a5d",
    d: "m129.81,134.62h0c0-.07-.02-.13-.02-.2,0,.06,0,.12.02.19h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-a0dc01d9-6e89-4cd1-8b78-05847040b01a",
    d: "m135.08,157.72h0c-.12-.03-.25-.05-.37-.07.12.02.25.05.37.07Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-d629904c-44be-4156-8f48-f62a4f3699c7",
    d: "m134.18,157.55c.18.03.35.07.53.1-.18-.03-.35-.07-.53-.1h0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-cf46ac8c-471e-48c6-aa08-866d2ab22945",
    d: "m134.18,157.55c.18.03.35.07.53.1.12.02.25.05.37.07-2.19-7.07-4.04-14.78-5.27-23.11,1.13,8.23,2.61,15.85,4.37,22.93h0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-59eb4435-7fa8-4768-baa5-a6e484f9d0a9",
    d: "m134.18,157.55c.18.03.35.07.53.1.12.02.25.05.37.07-2.19-7.07-4.04-14.78-5.27-23.11,1.13,8.23,2.61,15.85,4.37,22.93h0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-88032f9e-329d-4674-9cc3-a899f0508b8a",
    d: "m171.7,415.21c1.74-20.83,1.49-72.45,44.96-97.66,34.2-19.84,80.96-17.81,103.43-18.64-14.79-2.58-92-12.79-112.87-5.21-16.33,5.93-67.25,31.56-87.24,58.82-7.57,10.32.7,19.81-6.06,29.43,11.43,73.19,57.06,95.89,57.06,95.67,0-.06,0-.1-.02-.16-6.31-27.73-.25-50.32.74-62.26h0Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "lynx-whiteboard-logo_svg__uuid-68321f76-e1b5-4e53-badb-4eb86907db30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-98aeddd2-12f2-4fef-b14e-f3555e048343",
    d: "m145.99,118.83c-3.86,3-7.48,6.16-10.91,9.42.57.6,1.09,1.28,1.56,1.95.19.28,1.16,1.64,1.48,2.34.6-.04,1.71.07,2.02.06,1.18-.02,2.36-.05,3.55-.06,2.12-.02,4.24-.06,6.36-.1,5.37-3.37,8.61-4.79,8.61-4.79,0,0,7.76-29.78,19.38-55.32-6.07,5.91-30.02,35.46-32.05,46.49h0Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-8c112827-03ba-4019-9563-60c1d9bd87b6",
    d: "m302.66,346.33c26.7,4.25,23.22,11.81,29.8,5.45,22.48-21.74,22.96-60.31,19.56-60.31-6.41,5.95-13.8,3.2-19.31,3.74-65.3,6.5-81.36,2.73-115.81,21.82-43.92,24.34-66.88,83.72-45.95,160.44.02.06,0,.1.02.16,32.96-30.06,41.08-145.73,131.68-131.3h.01Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-5e0b87a9-8a3b-494c-ab09-d5cc08a1a3c6",
    d: "m170.98,477.63c2.27-2.15,4.27-4.56,6.1-7.09,1.83-2.52,3.5-5.16,5.06-7.87,3.1-5.42,5.82-11.04,8.4-16.72,5.2-11.35,9.98-22.91,15.32-34.24,5.31-11.33,11.27-22.44,18.65-32.65,7.36-10.17,16.36-19.44,27.4-25.78,2.74-1.59,5.62-2.95,8.56-4.12,2.93-1.2,5.98-2.12,9.05-2.89,3.08-.77,6.21-1.26,9.35-1.63,3.15-.3,6.31-.5,9.47-.43,6.32.06,12.61.82,18.78,2.04,3.09.61,6.16,1.35,9.18,2.3,3.01.96,5.98,2.17,8.78,3.61,1.38.66,2.82,1.56,3.88,1.28.56-.14,1.16-.54,1.73-1.01s1.14-.99,1.68-1.53c2.22-2.14,4.23-4.5,6.08-6.98,3.68-4.98,6.6-10.51,8.89-16.29,2.3-5.77,3.98-11.8,5.04-17.94.52-3.07.89-6.17,1.03-9.29.07-1.56.09-3.12-.01-4.67-.05-.78-.13-1.55-.29-2.32-.08-.38-.17-.76-.32-1.12-.15-.34-.34-.76-.75-.81.42.03.63.46.79.8.16.36.27.74.36,1.12.18.76.29,1.54.36,2.32.15,1.56.19,3.13.16,4.7-.06,3.13-.36,6.26-.81,9.36-.91,6.2-2.46,12.32-4.65,18.21-2.21,5.88-5.1,11.54-8.78,16.68-1.84,2.56-3.87,5-6.11,7.24-.55.56-1.13,1.12-1.76,1.65-.63.52-1.33,1.06-2.29,1.32-.48.13-1,.13-1.46.06-.47-.08-.88-.22-1.27-.37-.78-.31-1.48-.67-2.18-1-5.53-2.77-11.52-4.41-17.61-5.6-6.1-1.18-12.27-1.88-18.46-1.91-3.09-.05-6.18.16-9.25.47-3.06.38-6.11.87-9.1,1.63-2.98.77-5.94,1.66-8.78,2.85-2.86,1.15-5.64,2.49-8.3,4.04-10.75,6.1-19.62,15.12-26.92,25.11-7.35,10.02-13.23,21.06-18.74,32.25-5.49,11.21-10.42,22.7-15.82,33.99-2.73,5.63-5.59,11.21-8.83,16.57-3.26,5.33-6.93,10.51-11.6,14.69v-.03Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-443a49e0-eb97-4a22-948c-01e66a064424",
    d: "m254.52,302.82c-83.54,22.66-98.41,98.61-83.28,174.63l-.52.14c-25.42-72.98-.31-159.99,83.8-174.78h0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-6f855e4d-8d72-40e1-9c86-dc8f641baaaf",
    d: "m365.76,257.55c1.88-2.94,3.1-6.31,4.17-9.71-1.72-.72-3.18-1.2-4.15-1.51-42.19-13.8-78.1-46.09-124.62-58.89-63.01-17.33-110.03,5.6-118.83,8.55-75.72,25.34-99.32,105.25-111.74,141.86.76.51.39,1.32.39,1.32,3.33.6,31.1-19.56,40.64-27.21,28.25-22.65,42.83-29.55,86.12-58.3,25.14-16.69,123.12-25.47,163.7-9.58,20.87,8.17,48.75,5.8,58.62,14.42h.43c1.64.07,3.27-.08,4.9-.23.1-.23.22-.47.37-.7v-.02Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-11c43ceb-bbef-4b84-ad68-abd6181b8f3c",
    d: "m10.98,339.12c2.27-.33,4.28-1.86,6.29-2.93,6.01-3.63,11.79-7.64,17.47-11.77,7.42-5.67,15.14-11.06,21.76-17.66l.07.06c-5.94,7.3-13.79,12.79-21.41,18.2-5.77,4.02-11.63,7.94-17.76,11.41-2.08,1.03-4.11,2.53-6.44,2.78l.02-.09h0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-241ecfe2-2702-448c-8ee9-3e5dbc86f9db",
    d: "m275.97,299.89c2.92.9,2.76-3.43,1.49-3.32-.5.04-22.67-3.97-39.08-3.48-27.31.82-59.81,13.95-97.18,59.15-12.01,14.52-19.34,25.11-26.33,35.07,1.85,9.04,2.75,13.78,5.95,22.85,52.2-111.43,127.22-118.91,155.13-110.27h.02Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-f9381d00-1196-438b-ad78-553bec995de3",
    d: "m110.28,195.77c-4.5,6.29-7.84,10.69-7.84,10.69,2.28-1.54,5.85-4.22,7.84-10.69Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-6a1851eb-817c-4337-be59-987c0d797c43",
    d: "m372.35,232.08c-14.98-10.08-30.9-12.86-47.52-28.58-16.77-15.86-28.11-53.29-28.11-53.29,0,0-80.24-54.96-149.5-39.16-.14.03-7.77,2.4-18.67,6.04l-.76.13c2.81-15.29,9.9-34.37,20.66-63.72,1.7.26,4.56-8.6,4.04-10.53-2.08-7.82-46.12,24.54-79.28,96.65C5.65,204.86-13.35,293.05,10.98,339.17c12.42-36.61,34.97-111.43,111.35-139.52,8.71-3.2,55.82-29.54,118.83-12.21,28.91,7.95,52.68,27.48,77.45,41.37,15.09,8.46,31.2,12.3,47.17,17.52.97.32,2.43.79,4.15,1.51.83-2.64,1.58-5.3,2.47-7.82.67-1.9,2.16-2.87,3.75-3.08-.68-1.85-1.86-3.55-3.81-4.86h0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-d953d68c-68f8-42e0-89c8-d7f6e995ddf2",
    d: "m373.41,233.02c-12.44-7.92-26.88-12.25-39.03-20.76-8.22-5.53-15.47-12.69-20.58-21.2-7.82-12.61-13.41-26.43-17.89-40.53-30.79-19.38-70.65-37.77-109.37-41.37-13.05-1.45-26.79-.41-39.35,1.87,45.85-10.01,92.79,6.97,132.93,28.4,5.88,3.23,11.67,6.6,17.3,10.32,1.5,4.74,3.23,9.44,5.08,14.07,5.53,13.43,11.7,27.05,21.59,37.86,6.84,6.93,15.01,12.46,23.61,17.01,8.42,4.68,18.34,8.48,25.7,14.34h0Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-3df8d3cb-8256-415c-821e-3ea96b62d59b",
    d: "m274.67,202.76c1.75-.76,1.58-2.82.77-5.54-1.26-4.21-7.83-12.83-15.85-16.22-6.42-2.71-28.1,3.21-27.79,6.6.08.86,4.35,8.15,17.67,15.45,6.19,3.39,14.28,1.51,18.37.58,4.96-1.13,5.24-.18,6.82-.87h.01Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-387266a8-7994-4679-bb7f-dd8048da7efe",
    d: "m172.31,272.26c10.98-4.63,41.74-17.15,78.9-11.33,33.54,5.25,37.32,15.74,63.15,16.43,23.06.62,39.88-13.06,46.77-17.83-8.76-9.87-38.02-6.98-59.69-15.46-40.59-15.88-79.73-25.16-127.23-16.28-57.41,10.74-119.69,81.36-122.6,84.16-2.95,2.84,1.21,89.45,27.19,114.66.02-.08.15-.02.17-.1,11.49-59.74,18.01-90.84,33.07-109.24,22.52-27.51,48.9-40.23,60.27-45.02h0Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-241ecfe2-2702-448c-8ee9-3e5dbc86f9db",
    d: "m178.23,227.55c-56.88,11.03-87.86,47.8-126.61,84.41-1.31,1.26-2.26,3.61.48,25.06,76.99-112.83,141.57-114.8,235.64-97.2,0,0-49.72-23.87-109.51-12.27h0Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "lynx-whiteboard-logo_svg__uuid-8e0736ab-5ff7-4629-88c2-835941d78412"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-5209cdd3-f818-4925-bceb-54a3bc586b67",
    d: "m254.42,182.84c7.67,2.34,8.52,13.72,2.44,18.28.21-3.35.68-6.31.36-9.47-.3-3.18-1.35-5.77-2.8-8.81h0Z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-3e107dfa-09c2-46ac-be4f-0608d27cad88",
    d: "m257.36,177.66c-6.14-1.55-15.13-.53-22.26,1.91-4.37-.88-8.76-1.61-13.17-2.14-6.98-.85-14.01-1.27-21.01-1.28-1.82.03-3.63.05-5.45.08-5.18.19-10.34.54-15.46,1.12-6.92.79-13.79,1.93-20.56,3.44-6.77,1.5-13.46,3.34-20.03,5.48-6.57,2.16-13.04,4.61-19.36,7.4-2.75,1.2-5.52,2.51-8.14,3.79h-.02c-3.22,1.57-6.4,3.21-9.52,4.96-5.54,3.12-10.9,6.54-16.03,10.27-5.13,3.73-10.03,7.77-14.67,12.07-4.63,4.31-9,8.89-13.08,13.69-4.08,4.81-7.88,9.83-11.39,15.03s-6.76,10.57-9.74,16.07c-2.98,5.5-5.71,11.12-8.21,16.83-2.51,5.71-4.79,11.5-6.91,17.34s-4.06,11.74-5.92,17.66c0,0-1.82,5.93-5.46,17.78,4.22-11.66,6.32-17.48,6.32-17.48,2.14-5.81,4.37-11.59,6.76-17.29,2.38-5.7,4.94-11.33,7.69-16.84,2.75-5.52,5.71-10.92,8.9-16.17s6.62-10.34,10.29-15.24c3.67-4.89,7.6-9.58,11.77-14.03,4.17-4.44,8.59-8.63,13.23-12.55,4.65-3.9,9.52-7.53,14.58-10.84,5.06-3.32,10.32-6.32,15.73-9.02,3.04-1.52,6.14-2.92,9.26-4.26h.02c2.73-1.19,5.34-2.27,8.04-3.32,6.15-2.39,12.43-4.44,18.77-6.22,6.35-1.75,12.78-3.21,19.25-4.34,6.47-1.14,12.99-1.92,19.51-2.36,4.83-.33,9.67-.43,14.49-.39,1.69.05,3.38.1,5.06.15,6.5.3,12.96.98,19.34,2.06,3.59.6,7.15,1.34,10.67,2.19,5.22,5.57,13.24,12.19,20.51,13.97,12.6,3.08,28.45-2.37,28.45-2.37,0,0-1.7-21.97-22.25-27.15h0Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-7f1b78f2-a1df-42e3-be81-be3a93936b04",
    d: "m274.73,197.08c-1.26-4.21-7.83-12.83-15.85-16.22-6.19-2.62-26.57,1.48-27.74,4.81-.04.12-.07.25-.06.37.08.86,4.36,9.57,17.68,16.86,6.19,3.39,14.28,1.51,18.37.58,4.96-1.13,5.24-.18,6.82-.87.91-.39,1.29-1.14,1.34-2.14.05-.93-.19-2.08-.58-3.4h.02Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-1f5cead0-e1b4-4c60-805d-6e7af52b527a",
    d: "m255.39,182.84c1.39,1.19,3.48,3.4,4.32,6.84,1.21,4.94-.85,9.49-1.88,11.44"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-bd522e9d-ecab-42d8-babc-59c93b46f557",
    d: "m275.22,201.3c.01-1.15-.32-2.28-.68-3.38-.37-1.08-.94-2.1-1.55-3.08-1.23-1.96-2.71-3.75-4.32-5.4-1.6-1.66-3.35-3.17-5.24-4.47-.94-.66-1.92-1.24-2.93-1.76-.49-.28-1.03-.48-1.54-.72-.52-.25-.99-.37-1.53-.5-2.16-.41-4.48-.34-6.76-.16-1.14.08-2.28.21-3.43.36-1.14.13-2.28.28-3.42.48-2.28.33-4.54.79-6.78,1.32-1.12.27-2.23.59-3.29,1-.53.21-1.07.41-1.54.7-.45.29-.95.64-1.02,1.16l-.18.02c-.07-.69.46-1.21.89-1.61.46-.41.98-.72,1.5-1.03,1.05-.58,2.16-1.04,3.26-1.46,2.23-.83,4.52-1.43,6.84-1.9,2.32-.45,4.68-.76,7.06-.84,2.38-.06,4.78-.05,7.2.54.59.16,1.25.37,1.77.65.54.27,1.09.51,1.6.83,1.04.59,2.05,1.24,3,1.96,1.91,1.43,3.64,3.05,5.22,4.82,1.56,1.77,2.97,3.68,4.12,5.74,1.17,2.04,1.99,4.36,1.94,6.74h-.19Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-e903955d-530b-45dc-bfb3-994877dca589",
    d: "m131.05,160.44c14.61,1.89,30.64-2.72,39.93-17.19-3.5-10.43-3.93-3.22-4.57-17.29-1.9-41.64-11.5-94.32-11.56-94.33-26.11,49.86-31.18,83.26-27.81,107.75,1.04,7.56,2.4,14.56,4.01,21.07h0Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-03bf3889-d6cd-4d04-b4ca-da28fa118783",
    d: "m75.27,383.13s.08-.06.12-.09c-.02-.01-.06-.02-.11-.04,0,.04,0,.09-.02.13h.01Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "lynx-whiteboard-logo_svg__uuid-5ffbdd28-c32b-487c-a5ea-5dfdb96aa7f2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-dd8951f2-2194-4277-a36b-96976a544cb1",
    d: "m131.81,163.98l.26-.08.26-.08.26-.08.26-.08s6.33,18.56-.74-3.23l-.2-.87-.43.14-.43.14-.43.14-.43.14.35.83c7.07,21.78,1.28,3.05,1.28,3.05v-.02Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "lynx-whiteboard-logo_svg__uuid-b6cf4379-06e5-4e50-9486-d078a889d89b",
    width: 6,
    height: 13,
    transform: "translate(129.83 158.84)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAANCAYAAACKCx+LAAAACXBIWXMAAAsSAAALEgHS3X78AAAAIklEQVQYlWNgYGBgmK29gnm29gpmBmQAE5itvYKJYRTgAwDhmQXE3oIBOwAAAABJRU5ErkJggg=="
  })))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-35aa9605-2a4f-484e-bf6e-7e02a53ae580",
    d: "m130.91,161.62c.77-.25.42-.95,1.19-1.2C109.05,71.46,174.8,54.21,149.41.05c-4.11,15.58-8.31,30.44-16.28,44.35-5.62,13.25-39.59,49.43-59.93,95.22-1.75,3.95,38.07,19.21,57.71,22h0Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-d088ab46-3e14-47db-83b1-301de4def5c9",
    d: "m207.84,8.13c-.85,5.91-2.49,11.68-4.31,17.35-1.88,5.67-4.03,11.24-6.39,16.73-2.36,5.49-4.86,10.94-7.99,16.06-1.57,2.55-3.21,5.07-5.05,7.44-.88,1.22-1.9,2.33-2.85,3.48-.47.58-1.03,1.09-1.56,1.63-.53.53-1.06,1.06-1.6,1.57l-.13-.13c3.65-4.71,6.71-9.76,9.6-14.92,2.87-5.16,5.71-10.37,8.23-15.74,2.52-5.37,4.82-10.85,6.86-16.42,2.04-5.57,3.91-11.23,5-17.08l.18.03h.01Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-25cba547-8c03-49ce-89be-c325b9ed1081",
    d: "m149.5.07c-1.25,7.05-3.28,13.95-5.66,20.71-2.42,6.74-5.2,13.36-8.31,19.83-3.11,6.46-6.46,12.83-10.45,18.82-4.02,5.95-8.37,11.71-13.41,16.82l-.14-.12c4.24-5.77,8.31-11.61,12.01-17.69,3.74-6.05,7.41-12.15,10.68-18.48,3.25-6.34,6.18-12.85,8.77-19.5,2.6-6.64,4.85-13.43,6.34-20.42l.18.03h0Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-3284ac06-094a-401c-838f-a4ca82fbdc27",
    d: "m152.21,42.27c.95-3.46,1.39-7.02,1.55-10.59.18-3.56.07-7.13-.27-10.68-.34-3.55-1.07-7.03-1.7-10.51-.65-3.49-1.46-6.93-2.45-10.41l.17-.08c1.92,3.09,3.17,6.57,4.07,10.09.91,3.53,1.19,7.18,1.37,10.8.17,3.62.09,7.25-.28,10.85-.41,3.59-1.1,7.17-2.29,10.57l-.17-.06v.02Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-241ecfe2-2702-448c-8ee9-3e5dbc86f9db",
    d: "m91.36,123.55c2.79-13.48,8.96-24.38,20.24-47.37-17.26,20.35-35.49,56.42-38.39,63.44-21.21,20.51-39.63,45.81-51.67,70.7,32.82-37.39,38.68-52.77,82.3-55.63,1.69-.11-17.61-12.67-12.48-31.15h0Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-a125cc65-2e26-45a0-a448-20a2eb0c13c2",
    d: "m364.97,263.34c-.7-1.9-2.53-2.33-3.84-3.81-6.89,4.77-23.49,10.58-47.09,10.46-24.49-.13-39.9-6.2-62.84-9.06-37.32-4.66-87.19-8.42-139.16,56.35-16.85,21-29.66,48.09-33.16,109.29.06.01.06-.07.09-.05,27.84-20.9,32.41-38.45,62.36-74.67,37.37-45.2,69.87-58.33,97.18-59.15,33.93-1.02,59.85,16.95,77.14,16.02,17.66-.95,29.4-7.39,36.97-15.05,9.41-9.52,12.4-20.94,12.35-26.06,0-.08.33-3.36,0-4.27h0Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-0e430ab3-e226-4037-9181-51f7f318a24e",
    d: "m78.77,426.59c6.13-4.63,11.93-9.69,17.19-15.29,5.26-5.59,9.92-11.71,14.38-17.96s8.79-12.6,13.28-18.84c4.47-6.26,9.12-12.39,13.93-18.39,9.56-12.05,19.97-23.49,31.66-33.56,11.64-10.06,24.72-18.73,39.21-24.25,7.24-2.74,14.8-4.67,22.51-5.56,7.7-.9,15.52-.8,23.2.18,7.69.99,15.24,2.81,22.62,5.04,7.39,2.21,14.62,4.89,21.92,7.16,3.64,1.14,7.32,2.17,11.04,2.75,1.86.28,3.73.43,5.59.37,1.88-.12,3.79-.22,5.67-.47,7.54-.89,14.97-3.04,21.57-6.8,3.29-1.88,6.36-4.15,9.12-6.77,2.73-2.63,5.16-5.6,7.16-8.84,2.02-3.23,3.64-6.71,4.76-10.37.55-1.83.97-3.7,1.16-5.59.03-1.87.48-3.87.15-5.7l.17-.06c.26.98.16,1.94.15,2.91l-.08,1.43c0,.49,0,.97-.05,1.45-.13,1.93-.51,3.84-1.01,5.71-1.02,3.73-2.57,7.32-4.53,10.66-1.97,3.34-4.39,6.42-7.13,9.17-2.77,2.73-5.87,5.12-9.22,7.11-6.69,4.02-14.33,6.26-22.01,7.26-1.93.29-3.85.41-5.8.55-1.99.09-3.96-.05-5.9-.32-3.88-.56-7.64-1.57-11.34-2.68-7.38-2.3-14.57-4.96-21.91-7.16-7.32-2.22-14.77-4.01-22.33-4.99-7.55-1.01-15.22-1.17-22.79-.34-7.57.82-15.02,2.66-22.18,5.3-14.32,5.35-27.32,13.85-38.95,23.78-11.67,9.94-22.11,21.27-31.72,33.23-4.84,5.95-9.53,12.04-14.05,18.25-4.54,6.2-8.91,12.51-13.43,18.73-4.52,6.22-9.24,12.32-14.56,17.89-5.31,5.57-11.17,10.6-17.34,15.18l-.11-.15v-.02Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-97d0605c-d849-4861-a025-ecb4afa825eb",
    d: "m373.46,232.94s-4.92,7-11.8,12.48c-7.65,6.09-16.69,5.55-16.55,7.24.12,1.49,6.99.04,12.42,4.46,5.21,4.23,4.2,10.52,7.43,9.57,4.96-1.46,14.73-25.38,11.04-29.75-1.57-1.85-2.54-3.99-2.54-3.99h0Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-d7b8133f-b716-4ca6-bece-45aaae641bed",
    d: "m365.12,266.59c.36-.03.68-.25.97-.5s.55-.54.8-.83c.49-.6.93-1.25,1.34-1.91.82-1.33,1.53-2.72,2.19-4.14,1.35-2.82,2.49-5.74,3.42-8.71.93-2.97,1.54-6.03,1.92-9.01.17-1.48.23-3.01-.21-4.3-.53-1.41-1.22-2.82-2.01-4.19l.14-.12c1.2,1.07,2.24,2.32,3.06,3.76.85,1.62.9,3.36.85,4.99-.16,3.31-1.28,6.36-2.37,9.34-1.13,2.98-2.46,5.87-3.99,8.65-.78,1.38-1.62,2.74-2.55,4.03-.47.64-.96,1.27-1.52,1.85-.28.29-.57.56-.9.81-.33.23-.7.46-1.14.47v-.18h0Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-3c3e615f-101f-4313-aa19-0374097cc56f",
    d: "m229.04,258.96c-45.04-.35-79.44,19.05-108.36,52.56-20.74,22.6-30.2,46.44-36.05,76.23-2.51,12.8-4.21,25.99-5.74,38.97.34-31.6,3.71-64.51,18.9-92.8,5.1-9.45,11.77-17.95,18.76-26.02,7.14-7.9,14.57-15.62,23.02-22.21,26.24-21.08,55.93-30.29,89.47-26.74h0Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-14c3eebd-8277-4f50-aa8c-40dbc03811ce",
    d: "m13.12,230.37c-12.21,34.61-17.16,74.27-2.06,108.76.05.1-.11.19-.16.09-18.35-31.7-10.7-76.92,2.23-108.84h-.01Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-7e2545a9-ed12-428a-9938-58181537dfa1",
    d: "m116.47,395.01l2.03,7.63c.69,2.54,1.39,5.07,2.33,7.54h0c.71,1.68,1.22,3.39,1.88,5.06.64,1.67,1.36,3.31,2.08,4.94,1.4,3.28,2.97,6.47,4.7,9.57,1.74,3.09,3.5,6.18,5.45,9.14,1.9,2.99,3.92,5.91,6.05,8.75,4.2,5.72,8.82,11.13,13.68,16.32,2.43,2.59,4.99,5.08,7.67,7.42,1.32,1.2,2.68,2.35,4.1,3.42.71.53,1.44,1.04,2.19,1.51.74.48,1.52.93,2.35,1.23l-.05.19c-1.77-.48-3.33-1.43-4.85-2.38-1.52-.97-2.97-2.04-4.39-3.15-2.83-2.22-5.52-4.63-8.1-7.13-5.16-5.02-9.9-10.47-14.21-16.24-4.28-5.79-8.1-11.92-11.32-18.37-3.21-6.44-5.8-13.22-7.46-20.22h0c-.93-2.46-1.64-5.01-2.33-7.55l-2.02-7.63.19-.05h.03Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-e59c9a21-e849-4abd-a254-caad7e0c0f42",
    d: "m78.8,426.69c3.43-2.75,6.83-5.53,10.03-8.54,3.22-2.98,6.28-6.13,9.16-9.44s5.54-6.79,8.22-10.27c2.71-3.45,5.27-7.03,8.06-10.44l.11-.14v.17l.02.17v.05l-.15.19-.08-.05.12-.2v.04l-.04-.17.12.03c-2.39,3.7-4.83,7.36-7.43,10.91-2.6,3.56-5.45,6.93-8.41,10.2-2.96,3.27-6.1,6.37-9.4,9.3-3.29,2.93-6.78,5.62-10.28,8.28l-.05-.07v-.02Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-f0f4b6a2-5af9-4b4d-92b9-334b86839aac",
    d: "m51.78,338.07c.79,7.8,1.86,15.58,3.21,23.3,1.33,7.72,2.94,15.39,4.93,22.95,2.01,7.56,4.5,14.97,7.41,22.18,2.89,7.21,6.47,14.21,11.64,20.11l-.13.13c-2.99-2.58-5.48-5.72-7.64-9.04-2.17-3.32-3.93-6.88-5.56-10.49-3.18-7.25-5.31-14.89-7.14-22.54-3.66-15.32-5.8-30.94-6.91-46.59l.18-.02h.01Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-b106baf8-52c5-48c7-bfad-f27f11729f4e",
    d: "m51.55,311.89c9.28-9.88,18.7-19.64,28.55-28.97,9.85-9.32,20.13-18.23,31.16-26.18,11.02-7.93,22.78-14.93,35.31-20.26,6.25-2.7,12.7-4.93,19.25-6.78,6.56-1.82,13.25-3.2,19.99-4.17,13.5-1.87,27.21-2.06,40.77-.81,13.57,1.25,26.97,3.84,40.1,7.32,13.15,3.43,26.02,7.84,38.67,12.75,3.15,1.14,6.45,1.98,9.72,2.82,3.28.81,6.59,1.55,9.93,2.02,6.71.95,13.44,1.8,20.12,2.95l-.03.18c-6.69-1.05-13.43-1.81-20.16-2.67-3.38-.43-6.71-1.13-10.01-1.9-3.3-.8-6.59-1.59-9.84-2.7-12.76-4.54-25.68-8.63-38.81-11.91-6.56-1.64-13.17-3.05-19.82-4.23-6.65-1.2-13.34-2.11-20.06-2.74-13.43-1.29-27-1.25-40.38.48-6.68.9-13.32,2.2-19.83,3.96-6.5,1.79-12.91,3.95-19.13,6.59-12.47,5.2-24.21,12.07-35.24,19.89-11.04,7.83-21.39,16.6-31.32,25.82-9.93,9.22-19.44,18.89-28.82,28.68l-.13-.13h.01Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-1f5cead0-e1b4-4c60-805d-6e7af52b527a",
    d: "m373.25,235.16c.65,1.56,2.12,3.26,1.99,5.49-.12,2.07-1.93,9.76-3.52,13.76,0,0,1.17-11.32,1.11-14.77-.03-1.68.43-4.49.43-4.49h0Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-14c3eebd-8277-4f50-aa8c-40dbc03811ce",
    d: "m170.85,143.29c-1.05-2.14-2.1-4.23-3.57-5.96-.37-.45-.79-1.04-1.07-1.69-.72-1.76-.81-3.73-.98-5.55-.34-4.79-.29-9.45-.45-14.17-.22-9.42-.74-18.83-1.83-28.19-2.11-18.76-6.1-37.32-8.23-56.09l.13.12c.08.04.17-.15.13-.08v.06s-.03.08-.03.08l-.04.17-.08.34-.15.69c-.64,2.92-1.38,6.38-2.04,9.29-.02.07-.05.2-.06.26,0,.03-.02.06-.03.09l-.04.06s-.11.04-.14.03c-.17-.04-.09-.33.08-.26-.02,0-.09,0-.13.02-.04.05-.04.06-.03.05h0v-.06l.03-.08.04-.17c.66-2.91,1.4-6.37,2.03-9.29l.15-.69.08-.34.04-.17.02-.09v-.04s0-.02,0-.02h0s.07-.15.14-.12c3.1,18.59,7.41,37.22,10.08,56,1.91,14.07,3.15,28.31,2.79,42.52.07,2.21-.3,4.42.95,6.36,1.29,2.13,1.96,4.51,2.43,6.83.04.15-.2.23-.26.09h.03Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "lynx-whiteboard-logo_svg__uuid-14c3eebd-8277-4f50-aa8c-40dbc03811ce",
    d: "m152.53,42.69c-2.09,4.68-3.91,9.47-5.83,14.22-6.02,14.09-12.46,28.12-16.22,43.02-2.6,9.84-3.82,20.03-3.1,30.13.77,10.1,2.72,20.18,4.99,30.06l-1.15-1.03c7.39,1.08,15.07.36,22.11-2.18,7.12-2.55,13.4-7.32,17.52-13.73.08-.15.32,0,.24.14-3.53,6.98-9.86,12.35-17.06,15.36-7.26,3.09-15.35,3.96-23.16,3.12-.57-.06-1.01-.47-1.14-1-2.54-10.04-4.33-20.24-4.81-30.62-1.28-26.2,10.34-50.42,21.15-73.54,2.05-4.69,3.99-9.45,6.21-14.07.07-.16.33-.04.25.12h0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLynxWhiteboardLogo);
export default __webpack_public_path__ + "static/media/lynx-whiteboard-logo.a9c38748c97eb748eff874cd25508c3b.svg";
export { ForwardRef as ReactComponent };